import apiClient from "../helpers/apiClient";

const API = `/api/workers`;
const api = apiClient();

export const getPendingWorkersByPlaceId = (placeId, tenantId) => {
  const query = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : "";
  return api.get(`${API}/pending/${placeId}${query}`);
};
export const approveWorker = (userId, tenantId) => {
  const query = tenantId ? `?tenantId=${encodeURIComponent(tenantId)}` : "";
  return api.post(`${API}/approve/${userId}${query}`, { userId });
};
export const rejectWorker = (userId) => api.post(`${API}/reject/${userId}`);
export const deleteWorker = (userId) => api.del(`${API}/${userId}`);
